import { render, staticRenderFns } from "./MultipleSelect.vue?vue&type=template&id=0535d112&scoped=true"
import script from "./MultipleSelect.vue?vue&type=script&lang=js"
export * from "./MultipleSelect.vue?vue&type=script&lang=js"
import style0 from "./MultipleSelect.vue?vue&type=style&index=0&id=0535d112&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0535d112",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0535d112')) {
      api.createRecord('0535d112', component.options)
    } else {
      api.reload('0535d112', component.options)
    }
    module.hot.accept("./MultipleSelect.vue?vue&type=template&id=0535d112&scoped=true", function () {
      api.rerender('0535d112', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/officeApproval/common/form/components/MultipleSelect.vue"
export default component.exports